import { IS_ENROLL } from 'core/constants/environment'
import { START_APPLICATION } from 'sites/routes'
import { propAccessor } from '@hc-frontend/utils'

export const referrer =
  document.referrer || propAccessor(window, 'opener.window.document.referrer', '')

export const COMES_FROM_ENROLL_STARTAPP =
  IS_ENROLL && referrer && referrer.includes(START_APPLICATION.replace(/\//g, ''))
